<ion-content>
  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button
        (click)="close()"
        fill="clear"
        color="dark"
        class="ion-no-padding"
      >
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img
          [src]="dataServ.rData.dark_logo"
          *ngIf="dataServ.rData && dataServ.rData.dark_logo[0]"
        ></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ng-container *ngIf="authServ.profileLoading; else profileContent">
    <ion-grid class="form">
      <ion-row>
        <ion-col size="12" class="ion-text-center">
          <ion-spinner name="crescent"></ion-spinner>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>

  <ng-template #profileContent>
    <ion-grid class="form">
      <ion-row>
        <ion-col size="12">
          <ion-text color="primary" class="ion-text-center">
            <h1>
              <b>{{
                (type === "account" ? "My Account" : "My Preferences") | translate
              }}</b>
            </h1>
          </ion-text>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="!authServ.profileLoading && authServ.profile">
        <ng-container *ngIf="type === 'account'">
          <ion-col size="12" class="profile-img">
            <input
              type="file"
              accept="image/*"
              class="ion-hide"
              #profInput
              accept="img/*"
              (change)="uploadPhoto(profInput.files[0])"
            />
            <ion-avatar class="avatar" (click)="takePicture(profInput)">
              <img *ngIf="objectURL !== ''" [src]="objectURL" />
              <div class="default" *ngIf="objectURL === ''"></div>
              <ion-spinner
                class="avatar-spinner"
                name="lines"
                *ngIf="photoUploading"
              ></ion-spinner>
            </ion-avatar>
            <ion-button (click)="takePicture(profInput)" class="ion-no-padding">
              <div class="icon"></div>
            </ion-button>
          </ion-col>

          <ion-col size="6">
            <ion-item>
              <ion-label position="stacked"
                >{{ "Name" | translate }} <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input [(ngModel)]="authServ.profile.first_name"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="6">
            <ion-item>
              <ion-label position="stacked"
                >{{ "Surname" | translate }} <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input [(ngModel)]="authServ.profile.last_name"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12">
            <ion-item>
              <ion-label position="stacked"
                >{{ "Email" | translate }} <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input
                [(ngModel)]="authServ.profile.e_mail"
                type="email"
              ></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12">
            <ion-item>
              <ion-label position="stacked"
                >{{ "Identity Number" | translate }}
              </ion-label>
              <ion-input [(ngModel)]="authServ.profile.id_no"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12">
            <ion-item>
              <ion-label position="stacked"
                >{{ "New Password" | translate }}
                <ion-text color="danger">*</ion-text>
              </ion-label>
              <ion-input
                #passwordInput
                [(ngModel)]="authServ.profile.password"
                type="password"
              ></ion-input>
              <ion-icon
                slot="end"
                (click)="
                  passwordInput.type === 'password'
                    ? (passwordInput.type = 'text')
                    : (passwordInput.type = 'password')
                "
                [name]="
                  passwordInput.type === 'password'
                    ? 'eye-outline'
                    : 'eye-off-outline'
                "
              ></ion-icon>
            </ion-item>
          </ion-col>
        </ng-container>

        <ng-container *ngIf="type === 'preferences'">
          <ng-container
            #alergen
            *ngIf="dataServ.rData.is_profile_preferences_allergen"
          >
            <ion-col size="12">
              <ion-item>
                <!-- <ion-label position="stacked">{{'Add Alergen' | translate}}</ion-label> -->
                <ion-input
                  placeholder="{{ 'Im allergic to ..' | translate }}"
                  (keyUp.enter)="addAlergen()"
                  [(ngModel)]="newAlergen.name"
                  type="text"
                ></ion-input>
                <ion-button [disabled]="!newAlergen.name" class="add-button" (click)="addAlergen()">
                  {{"Add" | translate}}
                </ion-button>
              </ion-item>
            </ion-col>

            <ion-col size="12" *ngIf="tags && tags.length > 0">
              <ion-item lines="none" class="alergen-list">
                <small (click)="showAlergens = !showAlergens" slot="end">
                  {{ (showAlergens ? "Hide" : "Show") | translate }}
                </small>
                <ion-icon
                  (click)="showAlergens = !showAlergens"
                  slot="end"
                  color="primary"
                  name="{{ showAlergens ? 'eye-off-outline' : 'eye-outline' }}"
                ></ion-icon>
                <ion-label position="stacked"
                  >{{ "Alergen List" | translate }} ({{ tags.length }})</ion-label
                >
              </ion-item>
            </ion-col>
            <ion-col
              size="12"
              class="chip-wrapper"
              *ngIf="tags && tags.length > 0 && showAlergens"
            >
              <ion-chip *ngFor="let tag of tags">
                <ion-label text-wrap>{{ tag.name }}</ion-label>
                <ion-icon
                  (click)="deleteTag(tag)"
                  color="primary"
                  name="close-circle"
                ></ion-icon>
              </ion-chip>
            </ion-col>
          </ng-container>
          <!-- ...allergen kısmı sona erdikten sonra... -->
          <ng-container
            *ngFor="let field of this.authServ.profile.my_preferences"
          >
            <ion-col size="12" *ngIf="field.field_type === 1">
              <ion-item>
                <ion-label position="stacked">
                  {{ field.field_caption | caption | translate }}
                  <ion-text color="danger" *ngIf="field.is_required">*</ion-text>
                </ion-label>
                <ion-input
                  [(ngModel)]="field.field_value"
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="12" *ngIf="field.field_type === 6">
              <ion-item>
                <ion-label position="stacked">
                  {{ field.field_caption | caption | translate }}
                  <ion-text color="danger" *ngIf="field.is_required">*</ion-text>
                </ion-label>
                <ion-input
                  [(ngModel)]="field.field_value"
                  type="number"
                ></ion-input>
              </ion-item>
            </ion-col>
            <ion-col size="12" *ngIf="field.field_type === 7">
              <ion-item>
                <ion-label position="stacked">
                  {{ field.field_caption | caption | translate }}
                  <ion-text color="danger" *ngIf="field.is_required">*</ion-text>
                </ion-label>
                <ion-select [(ngModel)]="field.field_value">
                  <ion-select-option
                    *ngFor="let opt of getOptions(field.field_option)"
                    [value]="opt"
                  >
                    {{ opt }}
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
            <ion-col size="12" *ngIf="field.field_type === 5">
              <ion-item>
                <ion-label position="stacked">
                  {{ field.field_caption | caption | translate }}
                  <ion-text color="danger" *ngIf="field.is_required">*</ion-text>
                </ion-label>
                <ion-checkbox [(ngModel)]="field.field_value"></ion-checkbox>
              </ion-item>
            </ion-col>
          </ng-container>
          <!-- ...sonraki kodlar... -->

          <ion-col size="12" *ngIf="privacyPolicyText">
            <ion-item>
              <ion-label text-wrap>
                {{ privacyPolicyText | caption | translate }}
              </ion-label>
              <ion-toggle
                [(ngModel)]="authServ.profile.privacy_policy"
                value="true"
                slot="end"
                mode="ios"
              ></ion-toggle>
            </ion-item>
          </ion-col>

          <ion-col size="12" *ngIf="termsAndConditionsText">
            <ion-item>
              <ion-label text-wrap>
                {{ termsAndConditionsText | translate }}
              </ion-label>
              <ion-toggle
                [(ngModel)]="authServ.profile.personal_data"
                value="true"
                slot="end"
                mode="ios"
              ></ion-toggle>
            </ion-item>
          </ion-col>
        </ng-container>
      </ion-row>

      <ion-row *ngIf="!authServ.profileLoading && authServ.profile">
        <ion-col size="12">
          <br />
          <ion-button  (click)="save()" expand="block" color="primary">
            {{ "Save" | translate }}
          </ion-button>
        </ion-col>
        <ion-col size="12" *ngIf="type === 'account'">
          <ion-button
            (click)="deleteAccount()"
            expand="block"
            color="danger"
            fill="clear"
          >
            {{ "Delete My Account" | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-template>
</ion-content>
